import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
import { Design } from '@/model/document2/page/surface/design/design';
import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { UuidHelper } from '@/helper/uuidHelper';
import { MathHelper } from '@/helper/mathHelper';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';

// 面へレイヤーの複製コマンド
export class DuplicateLayerToSurfaceCommand implements ICommandBase
{
    private layer! : Layer;
    private page! : Page;
    private isReverse! : boolean;
    private isReverseCurrent! : boolean;
    private position! : number;
    private design! : Design;
    private doneCallback! : () => void;

    private currentLayer : Layer | null;
    private duplicatedLayer! : Layer;

    constructor(layer : Layer, page : Page, isReverse : boolean, isReverseCurrent : boolean, position : number, design : Design, doneCallback : () => void)
    {
        this.layer = layer;
        this.page = page;
        this.isReverse = isReverse;
        this.isReverseCurrent = isReverseCurrent;
        this.position = position;
        this.design = design;
        this.doneCallback = doneCallback;

        // カレントレイヤー保持
        this.currentLayer = design.currentLayer;
        // レイヤーのクローンをとる
        this.duplicatedLayer = layer.clone();
        // Idを新しく振る
        this.duplicatedLayer.id = UuidHelper.getUuid();
        // 名前を新しく振る
        this.duplicatedLayer.name = isReverse == isReverseCurrent ? layer.name + " のコピー" : layer.name;

        this.fixPosition();
    }

    // 位置調整
    private fixPosition()
    {
        // 面を取得
        var surface = this.page.getSurface(this.isReverse);
        // デザインを取得
        var targetDesign = surface.getDesign(this.position);
        if(targetDesign == null) { return; }

        // 貼り付け対象となるレイヤーについて、同じX,Y座標を持つ既存のレイヤーが存在するか調べ、あったら位置をずらす
        var allLayers = targetDesign.getAllLayers(false);
        var dx = 0;
        var dy = 0;
        
        // 永久にチャレンジすると画面外に行ってしまうので32回を限度とします。
        for(var i = 0; i < 32; ++i)
        {
            if(this.isExistSamePositionLayer(this.duplicatedLayer, allLayers, dx, dy))
            {
                // 2mmずらす
                dx += 2;
                dy += 2;
            }
            else
            {
                break;
            }
        }

        // 位置調整
        this.duplicatedLayer.x += dx;
        this.duplicatedLayer.y += dy;
    }

    // 同じ場所にレイヤーが存在するか調べる
    private isExistSamePositionLayer(layer : Layer, allLayers : Array<Layer>, dx : number, dy : number)
    {
        var isExistSamePositionLayer = false;
        for(var j = 0; j < allLayers.length; ++j)
        {
            var targetLayer = allLayers[j];
            if(MathHelper.equals(layer.x + dx, targetLayer.x) && MathHelper.equals(layer.y + dy, targetLayer.y))
            {
                isExistSamePositionLayer = true;
                break;
            }
        }

        return isExistSamePositionLayer;
    }

    public do() : void
    {
        // 面を取得
        var surface = this.page.getSurface(this.isReverse);
        // デザインを取得
        var targetDesign = surface.getDesign(this.position);
        if(targetDesign == null) { return; }
        // クローンしたレイヤーを親に追加
        targetDesign.layer.addLayer(this.duplicatedLayer);
        // 同じデザインにコピーしている場合は新規レイヤーにカレントを移す
        if(targetDesign == this.design)
        {
            this.design.currentLayer = this.duplicatedLayer;
            this.design.clearSelectLayers();
            this.design.addSelectLayer(this.duplicatedLayer);
        }

        // 連番文字対応
        if(this.duplicatedLayer instanceof NumberLayer) { this.duplicatedLayer.updateDocument(true); }

        this.doneCallback();
    }

    public undo() : void
    {
        // 面を取得
        var surface = this.page.getSurface(this.isReverse);
        // デザインを取得
        var targetDesign = surface.getDesign(this.position);
        if(targetDesign == null) { return; }
        // クローンしたレイヤーを削除
        targetDesign.layer.removeLayer(this.duplicatedLayer);
        // 同じデザインにコピーしている場合カレントを戻す
        if(targetDesign == this.design)
        {
            this.design.currentLayer = this.currentLayer;
        }

        this.doneCallback();
    }

    public redo() : void
    {
        // 面を取得
        var surface = this.page.getSurface(this.isReverse);
        // デザインを取得
        var targetDesign = surface.getDesign(this.position);
        if(targetDesign == null) { return; }
        // クローンしたレイヤーを親に追加
        targetDesign.layer.addLayer(this.duplicatedLayer);
        // 同じデザインにコピーしている場合は新規レイヤーにカレントを移す
        if(targetDesign == this.design)
        {
            this.design.currentLayer = this.duplicatedLayer;
            this.design.clearSelectLayers();
            this.design.addSelectLayer(this.duplicatedLayer);
        }

        // 連番文字対応
        if(this.duplicatedLayer instanceof NumberLayer) { this.duplicatedLayer.updateDocument(true); }

        this.doneCallback();
    }
}